import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

export const getZones = createAsyncThunk("seats/getZones", async (eventId) => {
  const response = await axiosInstance.request({
    url: `/events/${eventId}/zones`,
    method: "get",
  });
  return { data: response.data };
});

export const getZonesById = createAsyncThunk(
  "seats/getZonesById",
  async ({ eventId, zoneId }) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/zones/${zoneId}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const getSecctionsById = createAsyncThunk(
  "seats/getSecctionsById",
  async ({ eventId, sectionId }) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/sections/${sectionId}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const getSections = createAsyncThunk(
  "seats/getSections",
  async (eventId) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/sections`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const getSeats = createAsyncThunk("seats/getSeats", async (eventId) => {
  const response = await axiosInstance.request({
    url: `/events/${eventId}/seats`,
    method: "get",
  });
  return { data: response.data };
});

export const seatsSlice = createSlice({
  name: "seats",
  initialState: {
    zones: [],
    zonesById: [],
    seats: [],
    sections: [],
    sectionLoader: false,
    seatLoader: false,
    zoneLoader: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getZones.fulfilled, (state, action) => {
        const auxZones = [];

        action.payload.data?.forEach((element) => {
          auxZones.push({ label: element.name, value: element.id });
        });

        state.zones = auxZones;
        state.zoneLoader = false;
      })
      .addCase(getZones.pending, (state, action) => {
        state.zoneLoader = true;
      })
      .addCase(getZones.rejected, (state, action) => {
        state.zoneLoader = false;
      })
      .addCase(getSections.fulfilled, (state, action) => {
        state.sections = action.payload.data;
      })
      .addCase(getSections.pending, (state, action) => {})
      .addCase(getSections.rejected, (state, action) => {})
      .addCase(getSeats.fulfilled, (state, action) => {
        state.seats = action.payload.data;
      })
      .addCase(getSeats.pending, (state, action) => {})
      .addCase(getSeats.rejected, (state, action) => {})
      .addCase(getZonesById.fulfilled, (state, action) => {
        state.sectionLoader = false;
      })
      .addCase(getZonesById.pending, (state, action) => {
        state.sectionLoader = true;
      })
      .addCase(getZonesById.rejected, (state, action) => {
        state.sectionLoader = false;
      })
      .addCase(getSecctionsById.fulfilled, (state, action) => {
        state.seatLoader = false;
      })
      .addCase(getSecctionsById.pending, (state, action) => {
        state.seatLoader = true;
      })
      .addCase(getSecctionsById.rejected, (state, action) => {
        state.seatLoader = false;
      });
  },
});

export default seatsSlice.reducer;
